exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_2ms4MLy6LZZNyNg9WAzlMs {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_2fRi_F97nmM9nU_KrpjFBB {\n  float: left;\n}\n\n.IA_label_1ZM3V8n2uiu3Dv48JL-AZg {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_2ms4MLy6LZZNyNg9WAzlMs",
	"IA_icon": "IA_icon_2fRi_F97nmM9nU_KrpjFBB",
	"IA_label": "IA_label_1ZM3V8n2uiu3Dv48JL-AZg"
};